// ============================================================
// FILE: src/components/StatCounter.jsx  →  COUNT-UP NUMBERS
// Makes numbers animate from 0 to their value when visible.
// The numbers themselves are in src/data/site.js (HOMEPAGE NUMBERS).
// ============================================================

import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export default function StatCounter({ value, suffix = "", label, testId }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1800;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 4);
      setDisplay(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <div ref={ref} className="text-center" data-testid={testId}>
      <div className="font-display text-5xl font-bold tracking-tight text-gradient sm:text-6xl">
        {display.toLocaleString()}
        {suffix}
      </div>
      <p className="mt-2 text-sm font-medium uppercase tracking-[0.18em] text-muted-foreground">{label}</p>
    </div>
  );
}
